export const demoDashboardEndpointIds = {
    DEMO_GET_DASHBOARD_CREATORS: 'DEMO_GET_DASHBOARD_CREATORS',
    DEMO_GET_DASHBOARD_CHARTS_DATA: 'DEMO_GET_DASHBOARD_CHARTS_DATA',
    DEMO_GET_DASHBOARD_DELIVERIES: 'DEMO_GET_DASHBOARD_DELIVERIES',
    DEMO_GET_DASHBOARD_DROP_EVENT: 'DEMO_GET_DASHBOARD_DROP_EVENT',
};
export const DEMO_DASHBOARD_RECORD_ID = 'demoDashboard';
